import { INotification } from '../../../../../graphql/app-level-modals/models/get-modals-data.model';
import { NotificationType } from '../../../../../models/notification.models';

export const getControlVisitNotifications = (
  notifications?: INotification[],
): INotification[] => (notifications || [])
  .filter(({ notificationType }) => notificationType === NotificationType.CONTROL_VISIT_AVAILABILITY);
